<script>
import { authComputed } from '@state/helpers'
import config from '@src/app.config'
// import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  // components: { VuePerfectScrollbar },
  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      environment: config.env,
    }
  },
  computed: {
    ...authComputed,
    getCompanyInfo: function () {
      return this.$store.state.appAuth.companyInfo || null
    },
    getMediaUrl: function() {
      return config[this.environment].server_media_url || ''
    }
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu()
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar()
    },
  },
}
</script>

<template>
  <!-- Topbar Start -->
  <div class="navbar-custom" :style="[getCompanyInfo && getCompanyInfo.primary_color ? { 'background-color': getCompanyInfo.primary_color } : { 'background-color': '' }]">
    <ul class="list-unstyled topnav-menu float-right mb-0">
      <!-- <li class="d-none d-sm-block">
        <form class="app-search">
          <div class="app-search-box">
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                placeholder="Search..."
              />
              <div class="input-group-append">
                <button
                  class="btn"
                  type="submit"
                >
                  <i class="fe-search"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </li> -->

      <b-nav-item-dropdown
        v-if="loggedIn"
        right
        class="notification-list"
        menu-class="profile-dropdown"
      >
        <template slot="button-content">
          <div class="nav-user mr-0 waves-effect waves-light">
            <img
              :src="currentSession.user.user_info && currentSession.user.user_info.photo ? currentSession.user.user_info.photo : require('@assets/images/users/avatar-clear.png')"
              alt="user-image"
              class="rounded-circle"
            />
            <span class="pro-user-name ml-1">
              {{currentSession.user.first_name ? currentSession.user.first_name.charAt(0).toUpperCase() + currentSession.user.first_name.slice(1) : currentSession.user.username.charAt(0).toUpperCase() + currentSession.user.username.slice(1) }} 
              <i class="mdi mdi-chevron-down"></i>
            </span>
          </div>
        </template>

        <b-dropdown-item href="/logout">
          <i class="fe-log-out mr-1"></i>
          <span>Cerrar sesión</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>

      <!-- <li class="dropdown notification-list">
        <button
          class="btn btn-link nav-link right-bar-toggle waves-effect waves-light"
          @click="toggleRightSidebar"
        >
          <i class="fe-settings noti-icon"></i>
        </button>
      </li> -->
    </ul>

    <!-- LOGO -->
    <div class="logo-box">
      <a
        href="/"
        class="logo text-center"
      >
        <span class="logo-lg">
          <img
            v-if="getCompanyInfo && getCompanyInfo.light_logo"
            :src="environment === 'local' || environment === 'dev' ? `${getCompanyInfo.light_logo.replace('http://localhost:8001',getMediaUrl)}` : getCompanyInfo.light_logo || require('@assets/images/triduum/triduum-logo-g-w.svg')"
            alt=""
            height="55"
          />
          <!-- <span class="logo-lg-text-light">Xeria</span> -->
        </span>
        <span class="logo-sm">
          <!-- <span class="logo-sm-text-dark">X</span> -->
          <img
            v-if="getCompanyInfo && getCompanyInfo.short_light_logo"
            :src="getCompanyInfo.short_light_logo || require('@assets/images/triduum/triduum-m-w.svg')"
            alt=""
            height="50"
          />
        </span>
      </a>
    </div>

    <ul class="list-unstyled topnav-menu topnav-menu-left m-0">
      <li v-if="currentSession.user.app_sections_tree.length !== 1 || currentSession.user.app_sections_tree[0].path !== '/expert/projects'">
        <button
          class="button-menu-mobile waves-effect waves-light"
          @click="toggleMenu"
        >
          <i class="fe-menu"></i>
        </button>
      </li>

      <!-- <b-nav-item-dropdown
        class="d-none d-lg-block"
        right
      >
        <template slot="button-content">
          Create New
          <i class="mdi mdi-chevron-down"></i>
        </template>
        <b-dropdown-item href="#">
          <i class="fe-briefcase mr-1"></i>
          <span>New Projects</span>
        </b-dropdown-item>
        <b-dropdown-item href="#">
          <i class="fe-user mr-1"></i>
          <span>Create Users</span>
        </b-dropdown-item>
        <b-dropdown-item href="#">
          <i class="fe-bar-chart-line- mr-1"></i>
          <span>Revenue Report</span>
        </b-dropdown-item>
        <b-dropdown-item href="#">
          <i class="fe-settings mr-1"></i>
          <span>Settings</span>
        </b-dropdown-item>
        <b-dropdown-item href="#">
          <i class="fe-headphones mr-1"></i>
          <span>Help & Support</span>
        </b-dropdown-item>
      </b-nav-item-dropdown> -->
    </ul>
  </div>
  <!-- end Topbar -->
</template>

<style lang="scss">
.noti-scroll {
  height: 220px;
}
.ps > .ps__scrollbar-y-rail {
  width: 8px !important;
  background-color: transparent !important;
}
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
  width: 6px !important;
}
.button-menu-mobile {
  outline: none !important;
}
</style>
